export default "__VITE_ASSET__5O1otIof__"